import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { empty } from 'rxjs/observable/empty';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { catchError, mergeMap, take, tap } from 'rxjs/operators';
import { Subscription } from 'rxjs/Subscription';

import { MessageService } from 'primeng/components/common/messageservice';
import { isNullOrUndefined } from 'util';

import { AcaoCancelarProcedimentoComponent } from '../acoes/acao-cancelar-procedimento/acao-cancelar-procedimento.component';
import { AcaoCancelarComponent } from '../acoes/acao-cancelar/acao-cancelar.component';
import { AcaoFinalizarComponent } from '../acoes/acao-finalizar/acao-finalizar.component';
import { AcaoProrrogarComponent } from '../acoes/acao-prorrogar/acao-prorrogar.component';
import { AcoesService } from '../acoes/acoes.service';
import { AnexarImagensComponent } from '../anexar-imagens/anexar-imagens.component';
import { DadosBeneficiario } from '../base/vo/dados-beneficiario';
import { Gto } from '../base/vo/gto';
import { SalvaTokenGto } from '../base/vo/salva-token-gto';
import { DadosPrestadorService } from '../dados-prestador/dados-prestador.service';
import { GtoTokenComponent } from '../gto-token/gto-token.component';
import { GtoTokenService } from '../gto-token/gto-token.service';
import { DetalharGtoService } from './gto-detalhes.service';
import { LogService } from './log.service';


@Component({
  providers: [DatePipe],
  selector: 'app-gto-detalhes',
  templateUrl: './gto-detalhes.component.html',
  styleUrls: ['./gto-detalhes.component.scss']
})
export class GtoDetalhesComponent implements OnInit, OnDestroy {

  @ViewChild('acaoCancelar')
  public acaoCancelar: AcaoCancelarComponent;

  @ViewChild('acaoProrrogar')
  public acaoProrrogar: AcaoProrrogarComponent;

  @ViewChild('acaoCancelarProcedimento')
  public cancelaProcedimento: AcaoCancelarProcedimentoComponent;

  @ViewChild('acaoFinalizar')
  public acaoFinalizarComponent: AcaoFinalizarComponent;

  @ViewChild('modalImagens')
  public modalImagens: AnexarImagensComponent;

  @ViewChild('gtoToken')
  public gtoToken: GtoTokenComponent;

  private subs: Subscription[] = [];

  public dadosBeneficiario: DadosBeneficiario;
  public edit: number;
  public editErrors = null;
  public editImg = false;
  public enviaToken: string;
  public exibeOrtodontia = false;
  public formOrtodontia;
  public gto = new Gto();
  public idGto;
  public loading = false;
  public observacoesPrestador;
  public onlyAttachView = false;
  public sub;
  public tokenExigido: string;
  public tokenMensagem: string;

  public displayModalTokenStatus = false;
  public tokenStatus = {
    loading: true,
    titulo: 'Token',
    mensagem: 'Enviando Token',
    botao: false,

  };

  constructor(
    private acoesService: AcoesService,
    private dadosPrestadorService: DadosPrestadorService,
    private readonly datePipe: DatePipe,
    private detalharGtoService: DetalharGtoService,
    private gtoTokenService: GtoTokenService,
    private logService: LogService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit() {
    // recupera do route
    this.sub = this.route.params.subscribe(params => {
      this.idGto = +params['numeroGTO'];
    });

    // recupera do query params
    this.sub = this.route.queryParams.subscribe(params => {
      this.edit = +params['edit'] || 0;

    });
    this.checkTokenEnabled();
  }

  ngOnDestroy() {
    this.subs.forEach((subscription) => subscription.unsubscribe());
  }

  private isGtoValidForToken() {
    return this.gto.procedimentos.some(procedimento => procedimento.status === 'Autorizado') &&
      this.gto.status.toUpperCase() === 'VALIDADA';
  }

  private hasNotGtoToken() {
    if (this.gto.nomeJustificativaToken) {
      return false;
    }

    return !this.gto.idToken
  }

  private isTokenEnabled() {
    return this.enviaToken === 'S' && this.tokenExigido === '1';
  }

  private canCreateToken() {
    return this.isGtoValidForToken() && this.hasNotGtoToken() && this.isTokenEnabled();
  }

  private hasTokenOrJustificativa(): boolean {
    return (this.gto.numeroToken || this.gto.nomeJustificativaToken) ? true : false;
  }

  private canOpenDialogFinalizar() {
    return this.isTokenEnabled() && !this.hasTokenOrJustificativa();
  }

  private getDadosCadastraisObeservable() {
    return this.gtoTokenService.getDadosCadastraisBeneficiario(this.gto.codigoBeneficiario).pipe(
      tap(response => {
        this.dadosBeneficiario = response.data;
        if (!this.dadosBeneficiario.telefones.length && !this.dadosBeneficiario.emails.length) {
          throw new Error(`
            O beneficiario não pussui telefone e e-mail cadastrados. <br>
            Solicite que o paciente realize o cadastro desses
            dados através da Central de Relacionamento 0800 9 428 428. <br>
            Se desejar, você pode seguir sem token.
          `);
        }
      }),
      catchError(errorResponse => {
        let mensagem = '';

        mensagem = errorResponse.error ? errorResponse.error.errors[0].message : errorResponse.toString();

        mensagem = mensagem ? mensagem : "Aconteceu um erro inesperado";

        if (mensagem.includes('O beneficiario não pussui')) {
          mensagem = errorResponse.toString().replace('Error: ', '');
        }

        this.tokenStatus = {
          loading: false,
          titulo: 'Token - Erro ao enviar token.',
          mensagem,
          botao: true,
        };

        return empty();
      })
    );
  }

  private getCriarTokenGtoObeservable() {
    return this.gtoTokenService.criarTokenGto(this.getCriarTokenGtoRequest()).pipe(
      catchError(errorResponse => {
        this.tokenStatus = {
          loading: false,
          titulo: 'Token - Erro ao enviar token.',
          mensagem: errorResponse.error.errors.details,
          botao: true,
        };

        return empty();
      }),
    );
  }

  private getSalvarTokenGtoObeservable(tokenId: string) {
    const salvaTokenGto: SalvaTokenGto = {
      codigoPrestador: +this.gto.codigoPrestadorExecutante,
      dataToken: this.datePipe.transform(new Date(), 'dd/MM/yyyy'),
      idToken: tokenId,
      numeroGTO: +this.gto.numero
    };

    return this.gtoTokenService.salvarTokenGto(salvaTokenGto).pipe(
      take(1),
      tap(_ => {
        this.tokenStatus = {
          loading: false,
          titulo: 'Token - Sucesso',
          mensagem: `Token criado e enviado ao beneficiário`,
          botao: true,
        };

        this.detalharGto();
      }),
      catchError(errorResponse => {
        this.tokenStatus = {
          loading: false,
          titulo: 'Token - Erro ao enviar token.',
          mensagem: errorResponse.error.errors.details,
          botao: true,
        };

        return empty();
      }));
  }

  private getBuscarConfigsToken() {
    return this.acoesService.buscarConfigsToken().pipe(
      tap(response => this.tokenMensagem = response.data.tokenMensagem),
      catchError(errorResponse => {
        this.tokenStatus = {
          loading: false,
          titulo: 'Token - Erro ao recuperar as configurações do token.',
          mensagem: errorResponse.error.errors.details,
          botao: true,
        };

        return empty();
      }),
    );
  }

  private getBeneficiarioEmail() {
    const email = this.dadosBeneficiario.emails.slice(-1).pop();

    return email ? email.endereco : '';
  }

  private getBeneficiarioTelefone() {
    const telefone = this.dadosBeneficiario.telefones.slice(-1).pop();

    return telefone ? `+55${telefone.numeroDDD}${telefone.numeroTelefone}` : '';
  }

  private getCriarTokenGtoRequest() {
    const channels = [];
    const email = this.getBeneficiarioEmail();
    const mobile = this.getBeneficiarioTelefone();

    if (email) {
      channels.push('email');
    }

    if (mobile) {
      channels.push('whatsapp');
      channels.push('sms');
    }

    return {
      clientData: {
        docType: 'CPF',
        docValue: this.dadosBeneficiario.numeroCPF,
        email,
        mobile,
        name: this.gto.nomeBeneficiario
      },
      consumer: {
        canalConsumidor: 'portalodonto',
        processo: 'salvar GTO',
        tokenExpiry: 0
      },
      message: {
        channel: channels.join(','),
        text: this.gtoTokenService.formatarTokenMensagem(this.tokenMensagem, this.gto.nomeBeneficiario, this.gto.numero),
        type: 0
      }
    };
  }

  private criarTokenGto() {
    if (this.canCreateToken()) {
      this.displayModalTokenStatus = true;
      this.subs.push(
        this.getDadosCadastraisObeservable().pipe(
          mergeMap(_ => this.getCriarTokenGtoObeservable()),
          mergeMap(response => this.getSalvarTokenGtoObeservable(response.data.tokenId)),
        ).subscribe()
      );
    }
  }

  private checkTokenEnabled() {
    this.loading = true;
    const buscarConfigsToken$ = this.acoesService.buscarConfigsToken();
    const buscarDadosPrestador$ = this.dadosPrestadorService.buscarDadosCadastrais();

    this.subs.push(
      forkJoin(buscarConfigsToken$, buscarDadosPrestador$).pipe(
        tap(([configsToken, dadosPrestador]) => {
          this.loading = false;
          this.tokenMensagem = configsToken.data.tokenMensagem;
          this.tokenExigido = configsToken.data.tokenExigido;
          this.enviaToken = dadosPrestador.data.enviaToken;

          this.checkReload();
          this.detalharGto();
        },
          errorResponse => {
            this.messageService.add({ severity: 'error', summary: 'Erro ao checar flags do token', detail: errorResponse.error.errors[0].message });
            this.loading = false;

            this.checkReload();
            this.detalharGto();
          })
      ).subscribe()
    );
  }

  private checkReload() {
    this.subs.push(
      this.gtoTokenService.getReloadDetalhaGTO().pipe(
        tap((reload: boolean) => {
          if (reload) {
            this.detalharGto();
            this.gtoToken.closeDialog();
          }
        })
      ).subscribe()
    );
  }

  detalharGto() {
    this.loading = true;
    this.detalharGtoService.detalharGto(this.idGto).subscribe(
      data => {
        this.gto = data.data;
        if (this.gto.formularioOrtodontia) {
          this.exibeOrtodontia = this.gto.formularioOrtodontia.exibir;
          this.formOrtodontia = this.gto.formularioOrtodontia;
        }

        this.loading = false;

        if (this.edit === 1 && this.gto.corretivaPermitida) {
          this.abrirEditar();
        } else {
          this.edit = 0;
        }

        this.criarTokenGto();
      },

      erro => {
        console.log('Erro ao abrir detalhes da GTO.');
        console.log(erro);
        this.loading = false;
      });
  }

  voltar() {
    this.router.navigate(['/dashboard']);
  }

  abrirDialogProrrogar() {
    this.acaoProrrogar.abrirDialog();
  }

  abrirDialogCancelar() {
    this.acaoCancelar.abrirDialog();
  }

  abrirDialogCancelaProcedimento(linha) {
    this.cancelaProcedimento.abrirDialog(this.idGto, linha);
  }

  abrirDialogFinalizar(numeroGto: number) {
    this.loading = true;
    if (this.canOpenDialogFinalizar()) {
      this.gtoToken.openDialog();
    } else {
      this.acoesService.setCanGoToFinalizar(true);
      this.gtoTokenService.setCanOpenModalTokenOnFinalizar(false);
      this.router.navigate([`detalhagto/${numeroGto}/finalizar`]);
    }
    this.loading = false;
  }

  // imprimir GTO
  imprimir() {
    this.acoesService.imprimirGTO(this.gto.numero).subscribe(
      response => {
        window.open(response.data, '_blank');
      },
      error => {
        console.log('Não foi possível imprimir a GTO.');
      });
  }

  abrirEditar() {
    this.edit = 1;
    this.editImg = true;
    this.gto.observacoesPrestador = '';

    if (!this.gto.anexos) {
      this.gto.anexos = [];
    }

    this.detalharGtoService.emitIsEditingGto(true);
  }

  cancelarEdicao() {
    this.edit = 0;
    this.editImg = false;
    this.detalharGto();
    this.detalharGtoService.emitIsEditingGto(false);
  }

  salvarEdicao() {
    this.editErrors = null;
    this.loading = true;
    this.logService.registraEvento(this.gto.numero, 'Click salvar edicao');
    window.scroll(0, 0);

    this.acoesService.salvarGTO(this.gto).subscribe(
      data => {
        this.edit = 0;
        this.editImg = false;
        this.logService.registraEvento(this.gto.numero, 'Retorno salvar edicao');
        this.detalharGto();
      },
      error => {
        this.loading = false;
        this.callbackErrorResponse(error);
      });
  }

  private getQtdeImagens(param: any): number {
    if (isNullOrUndefined(param)) {
      return 0;
    } else {
      return param.length;
    }

  }

  private callbackErrorResponse(errorResponse) {
    this.editErrors = errorResponse.error.errors;
  }

  public fieldHasError(field: string): boolean {
    if (!isNullOrUndefined(this.editErrors)) {
      for (let index = 0; index < this.editErrors.length; index++) {
        if (this.editErrors[index].field === field) {
          return true;
        }
      }
    }
    return false;
  }

  public onClickVoltar() {
    localStorage.setItem('efetuar-busca-gto', 'true');
  }

  public callbackOnAction(actionSuccess) {
    if (actionSuccess) {
      this.detalharGto();
    }
  }

  public abrirModalAnexos() {
    this.modalImagens.display = true;
  }

  public getStatus() {
    if (this.gto.status === 'VALIDADA' && this.gto.dataFinalizacao) {
      return 'Finalizada';
    }

    return this.gto.status;
  }

  public getDataAutorizacao() {
    return this.gto.dataPrimeiraAut ? this.gto.dataPrimeiraAut : this.gto.dataProtocolo;
  }

  public attachError(error: boolean) {
    this.onlyAttachView = error;
  }

  public habilitarAnexarAlterarImagem(procedimento: any) {
    if (this.onlyAttachView) {
      return false;
    }

    return this.edit === 1 && procedimento.status.toUpperCase() !== 'CANCELADO';
  }
}



// WEBPACK FOOTER //
// ./src/app/components/gto-detalhes/gto-detalhes.component.ts